/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ACS
 */
export interface ACS {
    /**
     * 
     * @type {string}
     * @memberof ACS
     */
    actionUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ACS
     */
    actionMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof ACS
     */
    pareqFieldName?: string;
    /**
     * 
     * @type {string}
     * @memberof ACS
     */
    pareqFieldValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ACS
     */
    termurlFieldName?: string;
    /**
     * 
     * @type {string}
     * @memberof ACS
     */
    mdFieldName?: string;
    /**
     * 
     * @type {string}
     * @memberof ACS
     */
    mdFieldValue?: string;
    /**
     * 
     * @type {string}
     * @memberof ACS
     */
    mpiResult?: string;
}

/**
 * Check if a given object implements the ACS interface.
 */
export function instanceOfACS(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ACSFromJSON(json: any): ACS {
    return ACSFromJSONTyped(json, false);
}

export function ACSFromJSONTyped(json: any, ignoreDiscriminator: boolean): ACS {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'actionUrl': !exists(json, 'actionUrl') ? undefined : json['actionUrl'],
        'actionMethod': !exists(json, 'actionMethod') ? undefined : json['actionMethod'],
        'pareqFieldName': !exists(json, 'pareqFieldName') ? undefined : json['pareqFieldName'],
        'pareqFieldValue': !exists(json, 'pareqFieldValue') ? undefined : json['pareqFieldValue'],
        'termurlFieldName': !exists(json, 'termurlFieldName') ? undefined : json['termurlFieldName'],
        'mdFieldName': !exists(json, 'mdFieldName') ? undefined : json['mdFieldName'],
        'mdFieldValue': !exists(json, 'mdFieldValue') ? undefined : json['mdFieldValue'],
        'mpiResult': !exists(json, 'mpiResult') ? undefined : json['mpiResult'],
    };
}

export function ACSToJSON(value?: ACS | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'actionUrl': value.actionUrl,
        'actionMethod': value.actionMethod,
        'pareqFieldName': value.pareqFieldName,
        'pareqFieldValue': value.pareqFieldValue,
        'termurlFieldName': value.termurlFieldName,
        'mdFieldName': value.mdFieldName,
        'mdFieldValue': value.mdFieldValue,
        'mpiResult': value.mpiResult,
    };
}

